import React from "react";
import {Control, Field, Icon, TextArea} from "bloomer";
import Card from "../../../elements/Card";
import Button from "../../../elements/Button";
import {getTextSentimentResult} from "../../../api/models/TextSentiment";
import SendGAEvent, {GAEventActions, GAEventModels} from "../../../utils/SendGAEvent";
import ModelContentContainer from "../../../elements/ModelContentContainer";
import SectionName from "../../../elements/SectionName";
import InputWarning from "../../../elements/InputWarning";
import Spacer from "../../../elements/Spacer";
import InformationCard from "../../../elements/InformationCard";
import ErrorUtils from "../../../utils/ErrorUtils";
import {toast} from "react-toastify";
import {INVALID_FIELD_STYLE} from "../../../utils/Constants";

interface ITextSentimentModelState {
    uploaded: boolean;
    loading: boolean;
    text: string;
    textInputEmpty: boolean;
    sentimentAnalysis: any;
    errorMessage: string;
}

class TextSentimentModel extends React.Component<{}, ITextSentimentModelState> {
    public SENTIMENT_OPTIONS = ['Positive', 'Negative', 'Neutral'];

    constructor(props: {}) {
        super(props);
        this.state = {
            uploaded: false,
            loading: false,
            text: "",
            textInputEmpty: false,
            sentimentAnalysis: [],
            errorMessage: ""
        };
    }

    public componentDidMount() {
        SendGAEvent(GAEventActions.VIEW_MODEL, GAEventModels.TEXT_SENTIMENT);
    }

    public handleInputChange = (e: any) => {
        this.setState({
            text: e.target.value,
            textInputEmpty: false,
            errorMessage: ""
        });
    };

    public onSubmit = async (e: any) => {
        e.target.blur();

        if (!this.state.text.trim()) {
            this.setState({
                textInputEmpty: true,
                sentimentAnalysis: [],
                uploaded: false
            });

            return;
        }

        this.setState({
            uploaded: true,
            loading: true,
            textInputEmpty: false,
            sentimentAnalysis: [],
            errorMessage: ""
        });

        let errorOccurred = false;

        const response = await getTextSentimentResult(this.state.text).catch((error) => {
            if (ErrorUtils.requestLimitExceeded(error.response)) {
                this.setState({
                    loading: false
                });
                toast.error(ErrorUtils.messageContent.REQUEST_LIMIT_EXCEEDED);
            } else {
                this.setState({
                    loading: false,
                    errorMessage: "Couldn't get sentiment."
                });
            }
            errorOccurred = true;
        });

        if (errorOccurred) {
            return;
        }

        if (response && response.data && response.data.SentimentScore) {
            const result: any = [];
            response.data.SentimentScore.forEach((score: any) => {
                Object.keys(score).forEach((key) => {
                    if (this.SENTIMENT_OPTIONS.indexOf(key) !== -1) {
                        result.push({
                            key,
                            score: score[key]
                        });
                    }
                });
            });
            this.setState({
                loading: false,
                sentimentAnalysis: result
            });
        } else {
            this.setState({
                loading: false,
                errorMessage: "Couldn't get sentiment."
            });
        }

        SendGAEvent(GAEventActions.CALL_MODEL, GAEventModels.TEXT_SENTIMENT);
    };

    public resetState = async (e: any) => {
        e.target.blur();

        this.setState({
            uploaded: false,
            loading: false,
            text: "",
            textInputEmpty: false,
            sentimentAnalysis: [],
            errorMessage: ""
        });
    };

    public render() {
        return (
            <React.Fragment>
                <ModelContentContainer>
                    <Card>
                        <Field>
                            <Control>
                                <SectionName>Text</SectionName>
                                <TextArea
                                    style={this.state.textInputEmpty ? INVALID_FIELD_STYLE : undefined}
                                    onChange={this.handleInputChange}
                                    value={this.state.text}
                                    placeholder={"Enter your text for sentiment analysis here."}
                                />
                                <div>
                                    {
                                        this.state.textInputEmpty ?
                                            <InputWarning>Please input a text.</InputWarning> : <></>
                                    }
                                </div>
                            </Control>
                        </Field>
                        <div>
                            <Button onClick={this.onSubmit}>Submit</Button>
                            <Button onClick={this.resetState} style={{marginLeft: "5px"}}>Reset</Button>
                        </div>
                        <Spacer/>
                        {
                            this.state.loading ? <div>
                                <Spacer/>
                                <span>Loading...</span>
                                <Icon className="fas fa-spinner fa-spin"/>
                            </div> : <></>
                        }
                        {
                            this.state.uploaded && !this.state.loading
                            && !this.state.errorMessage && this.state.sentimentAnalysis.length ? <React.Fragment>
                                <SectionName>Output:</SectionName>
                                <InformationCard>
                                    {
                                        this.state.sentimentAnalysis.map((item: any) => {
                                            return <div key={item.key}>{item.key} - {item.score}%</div>
                                        })
                                    }
                                </InformationCard>
                            </React.Fragment> : <></>
                        }
                        {
                            this.state.uploaded && !this.state.loading && this.state.errorMessage ?
                                <InformationCard>{this.state.errorMessage}</InformationCard> : <></>
                        }
                    </Card>
                </ModelContentContainer>
            </React.Fragment>
        );
    }
}

export default TextSentimentModel;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/TextSentiment/TextSentimentModel.tsx